import React from "react";
import { Link } from "react-router-dom";
import { Mail, MapPin, Award, Clock, Phone } from "lucide-react";
import "./Footer.css";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <>
      {/* Pre-Footer CTA */}
      <section className="pre-footer-cta">
        <div className="container">
          <div className="cta-content">
            <h2 className="cta-heading">Stop worrying about tax. Get it handled properly.</h2>
            <p className="cta-subtext">Speak to an FCCA-qualified accountant and get clear, practical advice.</p>
            <Link to="/contact" className="cta-button">
              <Mail size={20} aria-hidden="true" />
              Get a Free Consultation
            </Link>
          </div>
        </div>
      </section>

      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            {/* Company Info */}
            <div className="footer-section">
              <h3 className="footer-heading">Brightson Accounting</h3>
              <p className="footer-text">
                FCCA-qualified accountant helping Wolverhampton businesses reduce tax, stay compliant, and grow with confidence.
              </p>
              <p className="footer-text footer-authority">
                Supporting sole traders, limited companies, and growing businesses across the West Midlands.
              </p>
              <div className="footer-badges">
                <div className="footer-badge">
                  <Award size={16} aria-hidden="true" />
                  <span>FCCA Qualified Accountant</span>
                </div>
                <div className="footer-badge">
                  <Award size={16} aria-hidden="true" />
                  <span>MAAT Qualified</span>
                </div>
              </div>
            </div>

            {/* Quick Links */}
            <div className="footer-section">
              <h4 className="footer-heading">Quick Links</h4>
              <nav className="footer-nav" aria-label="Footer quick links">
                <Link to="/services" className="footer-link">
                  Services
                </Link>
                <Link to="/pricing" className="footer-link">
                  Pricing
                </Link>
                <Link to="/about" className="footer-link">
                  About Us
                </Link>
                <Link to="/blog" className="footer-link">
                  Blog
                </Link>
                <Link to="/faq" className="footer-link">
                  FAQ
                </Link>
                <Link to="/contact" className="footer-link">
                  Contact
                </Link>
              </nav>
            </div>

            {/* Services */}
            <div className="footer-section">
              <h4 className="footer-heading">Our Services</h4>
              <nav className="footer-nav" aria-label="Footer services">
                <Link to="/services#annual-accounts" className="footer-link">
                  Annual Accounts
                </Link>
                <Link to="/services#tax-planning" className="footer-link">
                  Tax Planning
                </Link>
                <Link to="/services#hmrc-support" className="footer-link">
                  HMRC Support
                </Link>
                <Link to="/services#self-assessment" className="footer-link">
                  Self Assessment
                </Link>
                <Link to="/services#payroll-vat" className="footer-link">
                  Payroll & VAT
                </Link>
                <Link to="/services#start-up" className="footer-link">
                  Start-Up Support
                </Link>
              </nav>
            </div>

            {/* Contact Info */}
            <div className="footer-section">
              <h4 className="footer-heading">Get In Touch</h4>
              <p className="footer-tagline">Local, responsive, and easy to work with</p>
              <div className="footer-contact">
                <a
                  href="tel:+447362982967"
                  className="contact-item"
                  aria-label="Call 07362 982967"
                >
                  <Phone size={20} aria-hidden="true" />
                  <span>07362 982967</span>
                </a>
                <a
                  href="mailto:info@brightsonaccounting.co.uk"
                  className="contact-item"
                  aria-label="Email info@brightsonaccounting.co.uk"
                >
                  <Mail size={20} aria-hidden="true" />
                  <span>info@brightsonaccounting.co.uk</span>
                </a>
                <div className="contact-item contact-item-address">
                  <MapPin size={20} aria-hidden="true" />
                  <span>
                    <span className="contact-item-label">Registered Office</span>
                    71-75 Shelton Street, Covent Garden, London, United Kingdom, WC2H 9JQ
                  </span>
                </div>
                <div className="contact-item response-time">
                  <Clock size={20} aria-hidden="true" />
                  <span>Response within 24 hours</span>
                </div>
              </div>
              <p className="footer-text mt-3">
                Supporting businesses across Wolverhampton, Birmingham, Coventry, Leicester and the wider West Midlands.
              </p>
            </div>
          </div>

          {/* Trust Strip */}
          <div className="trust-strip">
            <span className="trust-item">FCCA & MAAT Qualified</span>
            <span className="trust-divider">•</span>
            <span className="trust-item">15+ Years Experience</span>
            <span className="trust-divider">•</span>
            <span className="trust-item">HMRC Compliant</span>
            <span className="trust-divider">•</span>
            <span className="trust-item">Confidential & Secure</span>
          </div>

          {/* Bottom Bar */}
          <div className="footer-bottom">
            <p className="footer-bottom-text">
              © {currentYear} Brightson Accounting Limited. All rights reserved. Company No. 10259741.
            </p>
            <div className="footer-legal">
              <Link to="/privacy" className="footer-legal-link">
                Privacy Policy
              </Link>
              <Link to="/cookies" className="footer-legal-link">
                Cookie Policy
              </Link>
              <Link to="/terms" className="footer-legal-link">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
